import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "woocommerce-terms-and-conditions-wrapper flex flex-col mt-4 lg:mt-10 items-start" }
const _hoisted_2 = {
  class: "flex items-center justify-start mb-6",
  for: "select_all"
}
const _hoisted_3 = { class: "checkbox !mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-placeholder text-greyScale-500" }, "Zaznacz wszystkie", -1)
const _hoisted_6 = {
  class: "flex items-start justify-start",
  for: "privacy"
}
const _hoisted_7 = { class: "checkbox" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-placeholder text-greyScale-500" }, [
  /*#__PURE__*/_createTextVNode(" Potwierdzam, że zapoznałem się z "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-placeholder underline",
    target: "_blank",
    href: "/regulamin/"
  }, "regulaminem"),
  /*#__PURE__*/_createTextVNode(" oraz "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-placeholder underline",
    target: "_blank",
    href: "/polityka-prywatnosci-i-cookies/"
  }, "polityką prywatności"),
  /*#__PURE__*/_createTextVNode(" portalu i akceptuję ich warunki. Deklaruję, że podane informacje są prawdziwe, a korzystam z usługi dobrowolnie i na własny rachunek. "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "error-message mb-4"
}
const _hoisted_11 = {
  class: "term-container",
  for: "agreement_one"
}
const _hoisted_12 = { class: "checkbox" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-placeholder text-greyScale-500" }, [
  /*#__PURE__*/_createTextVNode(" Oświadczam, iż jestem świadoma/-y, że po wypełnieniu formularza Iekarz skontaktuje się ze mną telefonicznie lub inną metodą zdalną w celu przeprowadzenia konsultacji. W wyjątkowych przypadkach czas realizacji usługi może ulec wydłużeniu z przyczyn niezależnych od Iekarza. "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_15 = {
  key: 1,
  class: "error-message mb-4"
}
const _hoisted_16 = {
  class: "term-container",
  for: "agreement_two"
}
const _hoisted_17 = { class: "checkbox" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-placeholder text-greyScale-500" }, [
  /*#__PURE__*/_createTextVNode(" Jestem świadoma/-y, że zawarcie umowy na usługę telemedyczną nie gwarantuje realizacji wnioskowanego świadczenia. Iekarz, na podstawie analizy formularza i przeprowadzonej konsultacji, decyduje o wystawieniu lub odmowie e-rесepty, e-zwоInienia oraz o ilości i dawkowaniu przepisanych Ieków. Ponadto rozumiem i akceptuję, że w przypadku zrealizowanej usługi tracę prawo do odstąpienia od umowy na podstawie art. 38 ustawy o prawach konsumenta. "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_20 = {
  key: 2,
  class: "error-message mb-4"
}
const _hoisted_21 = {
  class: "term-container",
  for: "agreement_three"
}
const _hoisted_22 = { class: "checkbox" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-placeholder text-greyScale-500" }, [
  /*#__PURE__*/_createTextVNode("Zostałam/-em poinformowana/-y, że nieodebranie połączenia od Iekarza lub brak kontaktu na czacie skutkuje odmową wystawienia świadczenia, co oznacza zakończenie procesu usługi. "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_25 = {
  key: 3,
  class: "error-message mb-4"
}

import { ref } from 'vue';
import { useField } from 'vee-validate';


export default {
  __name: 'Terms',
  setup(__props) {

const select = ref(false);

const {
    setValue: setPrivacyValue,
    value: privacyValue,
    errorMessage: privacyMessage,
} = useField('privacy');
const {
    setValue: setAgreementOneValue,
    value: agreementOneValue,
    errorMessage: agreementOneMessage,
} = useField('agreement_one');
const {
    setValue: setAgreementTwoValue,
    value: agreementTwoValue,
    errorMessage: agreementTwoMessage,
} = useField('agreement_two');
const {
    setValue: setAgreementThreeValue,
    value: agreementThreeValue,
    errorMessage: agreementThreeMessage,
} = useField('agreement_three');

const selectAll = () => {
    select.value = !select.value;

    if (select.value) {
        setPrivacyValue(true);
        setAgreementOneValue(true);
        setAgreementTwoValue(true);
        setAgreementThreeValue(true);
    } else {
        setPrivacyValue(false);
        setAgreementOneValue(false);
        setAgreementTwoValue(false);
        setAgreementThreeValue(false);
    }
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          onChange: selectAll,
          class: "mr-2",
          type: "checkbox",
          name: "select_all",
          id: "select_all"
        }, null, 32),
        _hoisted_4
      ]),
      _hoisted_5
    ]),
    _createElementVNode("label", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(privacyValue) ? (privacyValue).value = $event : null)),
          class: "mr-2",
          type: "checkbox",
          name: "privacy",
          id: "privacy"
        }, null, 512), [
          [_vModelCheckbox, _unref(privacyValue)]
        ]),
        _hoisted_8
      ]),
      _hoisted_9
    ]),
    (_unref(privacyMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(privacyMessage)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          class: "mr-2",
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(agreementOneValue) ? (agreementOneValue).value = $event : null)),
          name: "agreement_one",
          id: "agreement_one"
        }, null, 512), [
          [_vModelCheckbox, _unref(agreementOneValue)]
        ]),
        _hoisted_13
      ]),
      _hoisted_14
    ]),
    (_unref(agreementOneMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(agreementOneMessage)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          class: "mr-2",
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_isRef(agreementTwoValue) ? (agreementTwoValue).value = $event : null)),
          name: "agreement_two",
          id: "agreement_two"
        }, null, 512), [
          [_vModelCheckbox, _unref(agreementTwoValue)]
        ]),
        _hoisted_18
      ]),
      _hoisted_19
    ]),
    (_unref(agreementTwoMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(agreementTwoMessage)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _withDirectives(_createElementVNode("input", {
          class: "mr-2",
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_isRef(agreementThreeValue) ? (agreementThreeValue).value = $event : null)),
          name: "agreement_three",
          id: "agreement_three"
        }, null, 512), [
          [_vModelCheckbox, _unref(agreementThreeValue)]
        ]),
        _hoisted_23
      ]),
      _hoisted_24
    ]),
    (_unref(agreementThreeMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(agreementThreeMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}